import BankTransferForm from '@withdrawals/views/BankTransferForm'
import { WithdrawalSubFlows } from 'mmfintech-backend-api'

const MastercardTransfer = () => <BankTransferForm flowType={WithdrawalSubFlows.MASTERCARD} />
export default MastercardTransfer
